import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { FullWidthLayout, SectionLayout } from "@/layouts";
import { Checkbox, TextField } from "@mui/material";
import { sendContact } from "@/data";
import { SendFormWithCaptcha } from "@/helpers/sendFormWithCaptcha";
import { ButtonAlert } from "@/components/ui";
import { CellectAdress } from "./CellectAdress";
import TagManager from "react-gtm-module";
import * as Styled from "./startConversation.styles";
import { GooglePolicy } from "@/components/ui/googlePolicy";

export const StartConversation: FC = () => {
  const { t } = useTranslation("global");
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [checked, setChecked] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [alertState, setAlertState] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    country: "",
    message: "",
  });

  const requestedInfo = ["firstName", "email"];

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!checked) {
      setMessage(t("support.aggrementMessages.errorCheck")!);
      setAlertState("checkbox");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 5000);
      return;
    }
    setIsLoading(true);
    //send form with captcha
    SendFormWithCaptcha(executeRecaptcha).then((res: any) => {
      TagManager.dataLayer({
        dataLayer: {
          category: "forms",
          event: "trial-form-submit",
          action: "trial-form-submit",
        },
      });
      const data = {
        service_id: "service_tk4roz4",
        template_id: "template_gzs5oqg",
        user_id: "n2IOOPOiPZCuhSeej",
        template_params: customerInfo,
      };

      //helper function to send form
      sendContact(data)
        .then((res) => {
          if (res.status === 200) {
            setMessage(t("support.aggrementMessages.success")!);
            setAlertState("success");
            setShowAlert(true);
            setCustomerInfo({
              firstName: "",
              lastName: "",
              country: "",
              email: "",
              message: "",
            });
            setTimeout(() => {
              setShowAlert(false);
            }, 5000);
          } else {
            setMessage(t("support.aggrementMessages.error")!);
            setAlertState("error");
            setShowAlert(true);
            setTimeout(() => {
              setShowAlert(false);
            }, 5000);
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setMessage(t("support.aggrementMessages.error")!);
          setAlertState("error");
          setIsLoading(false);
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 5000);
        });
    });
  };

  return (
    <FullWidthLayout id="signUp" bgColor="var(--surface-95-light)">
      <SectionLayout className="animate__animated animate__fadeIn">
        <Styled.MainContainer>
          <Styled.TitleBox>
            <h1 className="display-large">{t(`support.startConversation.title`)}</h1>
            <Styled.InfoContainer>
              <CellectAdress />
            </Styled.InfoContainer>
          </Styled.TitleBox>
          <Styled.InnerContainer>
            <p className="body-large weight-medium">{t(`support.startConversation.subtitle`)}</p>
            <p className="body-large">{t(`support.startConversation.description`)}</p>
            <Styled.FormContainer onSubmit={handleSubmit}>
              <Styled.FormBox>
                {requestedInfo.map((info) => (
                  <TextField
                    key={info}
                    color="primary"
                    required
                    id={"filled-basic" + info}
                    label={t(`support.startConversation.form.${info}`)}
                    variant="filled"
                    type={info === "email" ? "email" : "text"}
                    sx={Styled.formWidth}
                    value={customerInfo[info as keyof typeof customerInfo]}
                    onChange={(e) =>
                      setCustomerInfo({
                        ...customerInfo,
                        [info]: e.target.value,
                      })
                    }
                  />
                ))}
                <TextField
                  id="filled-basic Message"
                  label={t(`support.startConversation.form.message`)}
                  variant="filled"
                  color="primary"
                  fullWidth
                  required
                  sx={Styled.messageBgColor}
                  value={customerInfo.message}
                  onChange={(e) =>
                    setCustomerInfo({
                      ...customerInfo,
                      message: e.target.value,
                    })
                  }
                />
                <GooglePolicy mobile={"100%"} />
              </Styled.FormBox>

              {/* <Styled.CheckBox>
                <Checkbox
                  id="checkbox-cellect-agreement"
                  typeof="checkbox"
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                  inputProps={{ "aria-label": "controlled" }}
                />
                <label htmlFor="checkbox-cellect-agreement">
                  <p className="body-small">
                    {t(`support.startConversation.agreement`)}{" "}
                    <a
                      href="https://cellectenergy.com/privacy"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      <span
                        className="body-medium weight-medium"
                        style={{ textDecoration: "underline" }}
                      >
                        {t(`support.startConversation.terms`)}{" "}
                      </span>
                    </a>
                  </p>
                </label>
              </Styled.CheckBox> */}

              <ButtonAlert
                type="submit"
                color="primary"
                size="medium"
                showAlert={showAlert}
                isLoading={isLoading}
                message={message}
                alertState={alertState}
                sx={Styled.sxBtn}
              >
                {t(`support.startConversation.button`)}
              </ButtonAlert>
            </Styled.FormContainer>
            <Styled.FooterContainer>
              <CellectAdress />
            </Styled.FooterContainer>
          </Styled.InnerContainer>
        </Styled.MainContainer>
      </SectionLayout>
    </FullWidthLayout>
  );
};
